import React from 'react'
import { VStack, HStack, Text, Icon, Link } from '@chakra-ui/react'
import { FaCircleCheck } from 'react-icons/fa6'

export const PaymentMethodUnused = ({ cardLast4, onChangePaymentMethod }) => (
  <VStack gap={3} align="stretch">
    {/* クレジットカード表示 */}
    <HStack gap={2}>
      <Icon as={FaCircleCheck} color="label.accent" boxSize="21px" />
      <Text fontSize="sm" fontWeight="300" color="label.primary" lineHeight="18px">
        クレジットカード
      </Text>
      <Text fontSize="sm" fontWeight="300" color="label.primary" lineHeight="18px" ml="auto">
        ・・・・{cardLast4}
      </Text>
    </HStack>

    {/* 決済方法を変更するリンク */}
    <Link
      fontSize="sm"
      fontWeight="600"
      color="label.link"
      textDecoration="underline"
      lineHeight="20px"
      onClick={onChangePaymentMethod}
      cursor="pointer"
      textAlign="center"
      display="block"
    >
      決済方法を変更する
    </Link>
  </VStack>
)
